module.exports = __webpack_public_path__ + "img/四川天府新区白沙小学.a8e5d69b.jpg";